import axiosInstance from "../../../core/api/axios";
import { IEssayBody } from "../../../core/models/essay";
import toBase64 from "../../../core/utils/image";
import { useCreateEssayStore } from "../stores/createEssayStore";
import { useEssayFilterStore } from "../stores/essayFilterStore";
import { useEssayImageStore } from "../stores/essayImageStore";
import { useSendEssayStore } from "../stores/sendEssayStore";
import TrackEventsUser from '../../../core/track/trackEventsUser';

export async function createEssay(body: { theme: string }) {
  try {
    const setIsLoading = useCreateEssayStore.getState().setIsLoading;
    const setIsSuccess = useCreateEssayStore.getState().setIsSuccess;

    setIsLoading(true);
    const response = await axiosInstance.post(`/essays-online`, body);

    if(response.data.theme || (response.data.ok && !response.data.sentCorrection)) {
      setIsSuccess(true);
    }

    setIsLoading(false);
    return response.data
  } catch(e: any) {
    throw new Error(e);
  }
}

export async function saveEssay(body: IEssayBody) {
  try {
    const response = await axiosInstance.put(`/essays-online/${body.theme}`, body);

    return response.data
  } catch(e: any) {
    throw new Error(e);
  }
}

export async function saveImage(file: File, user: string) {
  try {
    const setIsLoading = useEssayImageStore.getState().setIsLoading;
    const setIsSuccess = useEssayImageStore.getState().setIsSuccess;
    const setImageURL = useEssayImageStore.getState().setImageURL;

    setIsLoading(true);
    const prefix = new Date().valueOf();
    const fileName = `${prefix}-${file.name}`;
    const path = `essays/${user}`;

    const body = { file: await toBase64(file), fileName, path }
    const { data } = await axiosInstance.post(`/upload`, body);

    setImageURL(data.Location);
    setIsSuccess(false);
    setIsLoading(false)
    return true;
  } catch(e: any) {
    throw new Error(e);
  }
}

export async function sendEssay(body: IEssayBody) {
  try {
    const setIsLoading = useSendEssayStore.getState().setIsLoading;
    const setIsSuccess = useSendEssayStore.getState().setIsSuccess;

    setIsLoading(true);
    const responseSave = await axiosInstance.put(`/essays-online/${body.theme}`, body);

    if(responseSave.data._id && responseSave.data.status === 'writing') {
      const essayId = responseSave.data._id;
      const response = await axiosInstance.post(`/essays-online/correction/${essayId}`)

      if(response.data.id) {
        setIsSuccess(true);
        TrackEventsUser("ESSAY_SEND_CORRECTION", "v2")
      }
    }

    setIsLoading(false)
    return true;
  } catch(e: any) {
    const setIsLoading = useSendEssayStore.getState().setIsLoading;
    const setIsError = useSendEssayStore.getState().setIsError;
    const setErrorMessage = useSendEssayStore.getState().setErrorMessage;

    setErrorMessage(e.response.data.message || "Erro ao enviar redação")
    setIsLoading(false);
    setIsError(true);
    throw new Error(e);
  }
}

export async function getEssayByUser(slug: string) {
  try {
    const response = await axiosInstance.get(`/essays/${slug}`)

    return response.data
  } catch(e: any) {
    throw new Error(e);
  }
}

export async function getMyEssays() {
  try {
    const status = useEssayFilterStore.getState().status;
    const banca = useEssayFilterStore.getState().banca;
    const axis = useEssayFilterStore.getState().axis;

    let statusParsed = "", bancaParsed = "", axisParsed = "";

    if(banca.length > 0) {
      bancaParsed = JSON.stringify(banca);
    }

    if(axis.length > 0) {
      axisParsed = JSON.stringify(axis);
    }

    if(status.length > 0) {
      statusParsed = JSON.stringify(status);
    }

    const response = await axiosInstance.get(`/essays/myessays?correctionType=${bancaParsed}&status=${statusParsed}&themeAxis=${axisParsed}`)

    return response.data
  } catch(e: any) {
    throw new Error(e);
  }
}
